import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    GetPurchaseOrderPdfInput,
    GetPurchaseOrderPdfResponse,
} from '../../types/inventory/purchaseOrders';

const getPurchaseOrderPdf = async (
    sessionId: string,
    input: GetPurchaseOrderPdfInput,
): Promise<GetPurchaseOrderPdfResponse> => {
    const { data } = await axios.post<GetPurchaseOrderPdfResponse>(
        `${API_URL}/inventory/purchase-orders/pdf`,
        input,
        { headers: { Authorization: sessionId } },
    );
    return data;
};

export const useGetPurchaseOrderPdf = (
    options?: UseMutationOptions<
        GetPurchaseOrderPdfResponse,
        unknown,
        GetPurchaseOrderPdfInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: GetPurchaseOrderPdfInput) =>
            getPurchaseOrderPdf(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
